<template>
  <div class="flex flex-wrap">
    <Form :pageType="pageType" :onSubmit="onSubmit" :alertType="alertType" :alertMessage="alertMessage"
      :clientProps="currentClient" :showModal="showModal" :toggleModal="toggleModal" />
    <div v-if="showModal" class="opacity-25 fixed inset-0 z-40 bg-black"></div>
    <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
    <div class="w-full px-4">
      <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
        <div class="rounded-t bg-white mb-0 px-6 py-6">
          <div class="text-center flex justify-between">
            <h6 class="text-blueGray-700 text-xl font-bold">Client Management</h6>
            <a class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
              v-on:click="onClickAdd" href="#">
              Create New
            </a>
          </div>
        </div>
        <div class="block w-full overflow-x-auto">
          <!-- Projects table -->
          <table class="items-center w-full bg-transparent border-collapse">
            <thead>
              <tr>
                <th
                  class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                  ID
                </th>
                <th
                  class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                  Client Name
                </th>
                <th
                  class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                  Token (Encrypted)
                </th>
                <th
                  class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in clients" :key="item.id">
                <th class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left">
                  {{ item.id }}
                </th>
                <td class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                  {{ item.client_name }}
                </td>
                <td class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                  {{ item.auth_token }}
                </td>
                <td class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                  <router-link :to="'/admin/clients/' + item.client_name + '/reports'"
                    class="bg-cyan-500 text-white active:bg-cyan-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150">Report</router-link>
                  <a href="#" v-on:click="setActiveClient(item, 0)"
                    class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150">Edit</a>
                  <a href="#" v-on:click="deleteItem(item)"
                    class="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150">Delete</a>
                </td>
              </tr>
            </tbody>
          </table>
          <Pagination :totalCounts="totalCounts" :onPageChange="handlePageChange" />

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ClientDataService from "@/services/ClientDataService";
import { UseAppStore } from '@/stores/AppStore';
import Form from "@/views/admin/clients/Form.vue";
import Pagination from "@/components/Paginate/Pagination.vue";
import ConfirmDialogue from "@/components/ConfirmDialogue/ConfirmDialogue.vue";
import constants from "@/constants";
import ErrorHandler from "@/ErrorHandler";


export default {
  setup() {
    const appStore = UseAppStore();

    appStore.resetBreadcrumbs();
    appStore.putBreadcrumbs("dashboard", "Dashboard", "/admin/dashboard")
    appStore.putBreadcrumbs("client", "Client Management", "/admin/client")
    return {
      appStore
    }
  },
  components: {
    Form,
    Pagination,
    ConfirmDialogue
  },
  data() {
    return {
      totalCounts: 0,
      clients: [],
      currentClient: {},
      currentIndex: -1,
      showModal: false,
      alertType: '',
      alertMessage: '',
      pageType: 'Add'
    }
  },
  methods: {
    handlePageChange(page) {
      ClientDataService.getAll(constants.pageLimit, page)
        .then(response => {
          this.clients = response.data["data"]["clients"];

        })
        .catch(e => {
          ErrorHandler(e);
        });
    },
    countDownTimer(countDown, callback) {
      if (countDown > 0) {
        setTimeout(() => {
          countDown -= 1
          this.countDownTimer(countDown, callback)
        }, 1000)
      } else {
        this.alertType = ''
        if (callback != undefined) {
          callback()
        }
      }
    },
    toggleModal() {
      this.showModal = !this.showModal;
    },
    onClickAdd() {
      this.currentClient = {};
      this.showModal = !this.showModal;
      this.pageType = 'Add'
    },
    retrieveClients() {
      ClientDataService.getAll()
        .then(response => {
          this.clients = response.data["data"]["clients"];
          this.totalCounts = response.data["data"]["count"];
          console.log(response.data);
        })
        .catch(e => {
          ErrorHandler(e);
        });
    },
    refreshList() {
      this.retrieveClients();
      this.currentClient = {};
      this.toggleModal()
    },

    setActiveClient(item, index) {
      this.currentClient = item;
      console.log(this.currentClient)
      this.currentIndex = item ? index : -1;
      this.showModal = !this.showModal;
      this.pageType = 'Edit'
    },

    async deleteItem(item) {
      const ok = await this.$refs.confirmDialogue.show({
        title: 'Attention',
        message: 'Are you sure you want to delete this item?',
        okButton: 'Delete',
      })

      if (ok) {
        ClientDataService.delete(item.id)
          .then(() => {
            this.alertType = 'Success'
            this.alertMessage = 'Client successfuly deleted'
            this.countDownTimer(3, this.retrieveClients)
          })
          .catch(e => {
            ErrorHandler(e);
          });
      }
    },
    searchClient() {
      ClientDataService.findByTitle(this.title)
        .then(response => {
          this.clients = response.data;
          this.setActiveClient(null);
          console.log(response.data);
        })
        .catch(e => {
          ErrorHandler(e);
        });
    },
    onSubmit(client) {
      if (this.currentClient['id'] != null) {
        this.editClient(client)
      } else if (this.currentClient['id'] == null) {
        this.addClient(client)
      }

    },
    addClient(client) {
      ClientDataService.create(client)
        .then(() => {
          this.alertType = 'Success'
          this.alertMessage = 'Client successfuly created'
          this.countDownTimer(3, this.refreshList)
        })
        .catch(e => {
          this.alertType = 'Failed'
          this.alertMessage = e.response.data.code_message
          this.countDownTimer(3)
        });
    },
    editClient(client) {
      ClientDataService.update(this.currentClient.id, client)
        .then(() => {
          this.alertType = 'Success'
          this.alertMessage = 'Client successfuly updated'
          this.countDownTimer(3, this.refreshList)
        })
        .catch(e => {
          this.alertType = 'Failed'
          this.alertMessage = e.response.data.code_message
          this.countDownTimer(3)
        });
    }
  },
  mounted() {
    this.retrieveClients();
  }
};
</script>
